import { render } from "./NotFoundNyukyoDialog.vue?vue&type=template&id=18051d14&scoped=true&ts=true"
import script from "./NotFoundNyukyoDialog.vue?vue&type=script&lang=ts"
export * from "./NotFoundNyukyoDialog.vue?vue&type=script&lang=ts"

import "./NotFoundNyukyoDialog.vue?vue&type=style&index=0&id=18051d14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18051d14"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QIcon,QSeparator,QCardActions,QBtn});
